import type {Namespace} from '@wix/document-services-types'
import type {VariantType} from '../../types'

export const DEFAULT_BREAKPOINT_MAX = 2147483647
export const NAMESPACE_VARIANT_SOURCE: Namespace[] = ['variants', 'breakpointVariants']
export const BREAKPOINT_RANGE_TYPE: string = 'BreakpointRange'
export const PRESET_TYPE: string = 'Preset'
export const TYPE_TO_VARIANT_MAP_FEATURE: Record<string, VariantType> = {
    [PRESET_TYPE]: 'presets',
    [BREAKPOINT_RANGE_TYPE]: 'breakpoints'
}
export const VARIANTS_MAP_PROPS_BY_TYPE: Record<string, string[]> = {
    [PRESET_TYPE]: ['id'],
    [BREAKPOINT_RANGE_TYPE]: ['id', 'min', 'max', 'canvasSize']
}
